/**
 * Time Entries — API client.
 * Mirrors src/lib/supabase/timeEntries.ts function signatures exactly.
 */
import { apiGet, apiPost, apiDelete } from './client';
import type { WOTimeEntry } from '@/types/maintenance';

export type { AddTimeEntryInput } from '@/lib/supabase/timeEntries';

export async function fetchTimeEntries(workOrderId: string): Promise<WOTimeEntry[]> {
  return apiGet<WOTimeEntry[]>(`/api/work-orders/${workOrderId}/time-entries`);
}

import type { AddTimeEntryInput as _AddTimeEntryInput } from '@/lib/supabase/timeEntries';

export async function addTimeEntry(
  input: _AddTimeEntryInput,
  _userId: string,
  _orgId: string,
): Promise<WOTimeEntry> {
  return apiPost<WOTimeEntry>(`/api/work-orders/${input.work_order_id}/time-entries`, {
    technician_id: input.technician_id,
    technician_name: input.technician_name,
    activity: input.activity,
    minutes: input.minutes,
  });
}

export async function deleteTimeEntry(id: string): Promise<void> {
  await apiDelete<void>(`/api/time-entries/${id}`);
}
